import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  SectionDefinition,
  SectionDefinitionEntityType,
} from '../../../models/section-definition.model';
import { SectionDefinitionService } from '../../../services/section-definition.service';
import { ToastrService } from 'ngx-toastr';
import { UtilitySharedService } from '../../../services/shared/utility-shared.service';

@Component({
  selector: 'lib-buildings-customers',
  templateUrl: './buildings-customers.component.html',
  styleUrls: ['./buildings-customers.component.scss'],
  standalone: false
})
export class BuildingsCustomersComponent implements OnInit {
  classes = [
    {
      index: 0,
      label: 'COMMON.BUILDING.PLURAL',
      entitytype: SectionDefinitionEntityType.Building,
    },
    {
      index: 1,
      label: 'COMMON.CUSTOMER.PLURAL',
      entitytype: SectionDefinitionEntityType.Customer,
    },
  ];
  selectedClass: number = 0;
  expandedSectionId: number = -1;
  addNewFieldOpened: boolean = false;
  sectionDefinitions: SectionDefinition[] = [];
  utilityId!: number | null;

  constructor(
    private sectionDefinitionService: SectionDefinitionService,
    private toastr: ToastrService,
    private utilitySharedService: UtilitySharedService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.selectClass(0);
  }

  getSectionDefinitionsForClass(entityType: number) {
    this.utilityId = this.utilitySharedService.getUtilityId();
    this.sectionDefinitionService.getAllSectionDefinitionsForDmc(entityType, this.utilityId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sectionDefinitions = responseData?.data?.length
            ? responseData?.data?.map((el: any) => new SectionDefinition(el))
            : [];

          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }

  selectClass(index: number) {
    this.selectedClass = index;
    this.getSectionDefinitionsForClass(this.classes[index].entitytype);
  }

  sectionSaved(data: any) {
    this.selectClass(
      this.classes.find((x) => x.entitytype == data.type)?.index!
    );
    this.expandedSectionId = data.id;
  }

  sectionDeleted(id: any) {
    this.sectionDefinitions = this.sectionDefinitions.filter(x => x.id != id);
    this.cdr.detectChanges();
  }

  onSectionUpdated(data: any) {
    this.selectClass(
      this.classes.find((x) => x.entitytype == data.type)?.index!
    );
  }
}
